/* tslint:disable */
/* eslint-disable */
/**
 * Rooming_API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum RegistrationType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5
}

export function RegistrationTypeFromJSON(json: any): RegistrationType {
    return RegistrationTypeFromJSONTyped(json, false);
}

export function RegistrationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationType {
    return json as RegistrationType;
}

export function RegistrationTypeToJSON(value?: RegistrationType | null): any {
    return value as any;
}

